import { isTokenExpired } from './jwtUtils';

export const getAuthHeaders = (): Record<string, string> => {
  const token = localStorage.getItem('user_authToken');
  if (!token || isTokenExpired(token)) {
    return {};
  }
  return { Authorization: `Bearer ${token}` };
};
